import { c as _c } from "react/compiler-runtime";
import { Checkbox } from 'shared/components/checkbox';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface DeadlineSettingsCheckboxGroupOption<T extends number> {
  caption: string;
  id: T;
}
interface DeadlineSettingsCheckboxGroupProps<T extends number> {
  ariaLabel: string;
  disabled?: boolean;
  onChange: (value: T) => void;
  options: readonly DeadlineSettingsCheckboxGroupOption<T>[];
  selected: readonly T[];
}
function DeadlineSettingsCheckboxGroup(t0) {
  const $ = _c(19);
  const {
    ariaLabel,
    disabled,
    onChange,
    options,
    selected
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.funnel.deadline_steps_description");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="text-text-tertiary text-sm">{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== disabled || $[5] !== onChange || $[6] !== options || $[7] !== selected) {
    let t4;
    if ($[9] !== disabled || $[10] !== onChange || $[11] !== selected) {
      t4 = option => <Checkbox key={option.id} disabled={disabled} label={option.caption} onChange={() => onChange(option.id)} value={selected.includes(option.id)} />;
      $[9] = disabled;
      $[10] = onChange;
      $[11] = selected;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    t3 = options.map(t4);
    $[4] = disabled;
    $[5] = onChange;
    $[6] = options;
    $[7] = selected;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[13] !== ariaLabel || $[14] !== t3) {
    t4 = <div aria-label={ariaLabel} role="group" className="flex flex-wrap gap-4">{t3}</div>;
    $[13] = ariaLabel;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t2 || $[17] !== t4) {
    t5 = <div className="flex flex-col gap-2">{t2}{t4}</div>;
    $[16] = t2;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
}
export { DeadlineSettingsCheckboxGroup };
export type { DeadlineSettingsCheckboxGroupOption, DeadlineSettingsCheckboxGroupProps };